export { default } from './MultiTextItem';
